import { UsersThreeIcon } from '@phosphor-icons/react';
import React from 'react';

import { useSettingsDialog } from '@/components/settings/SettingsDialogProvider';
import { useAccountOwner, useIsAccountOwner } from '@/hooks/account/useAccountRoster';
import { firstNameOf } from '@/lib/format-name';

export function SharedAccountHint() {
  const isOwner = useIsAccountOwner();
  const owner = useAccountOwner();
  const { openSettings } = useSettingsDialog();

  if (isOwner || !owner) return null;

  const ownerFirstName = firstNameOf(owner) ?? 'owner';

  return (
    <button
      type="button"
      onClick={() => openSettings('team')}
      className="flex w-full items-center gap-1.5 px-2 py-1 text-detail text-muted-foreground/70 hover:text-muted-foreground transition-colors group-data-[collapsible=icon]:hidden"
      aria-label={`You're on ${ownerFirstName}'s shared Mora account`}
    >
      <UsersThreeIcon className="h-3 w-3" weight="regular" />
      <span className="truncate">Shared by {ownerFirstName}</span>
    </button>
  );
}
